import "./trustedTypes";
import "react-app-polyfill/ie11";
import "core-js";
import "core-js/features/array/find"; //zda se, ze nekdy nefunguje

import React from "react";
import dayjs from "dayjs";
import "antd/dist/antd.css";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
//import * as Sentry from "@sentry/react"; ^7.120.3
import { ConnectedRouter } from "connected-react-router";

import "dayjs/locale/cs";

//import config from "./config";
import App from "./containers/app";
import store, { history } from "./store";
//import { version } from "../package.json";

import "./index.css";

export const datePickerFormat = "D.M.YYYY";
export const dateFormatForLabel = "DD-MM-YYYY";
export const dateTimeFormatForPrint = "D.M.YYYY HH:mm";
export const dateTimeApiFormat = "YYYY-MM-DDTHH:mm:ssZ";

dayjs.locale("cs");

export const environment = window.location.host.startsWith("app-")
  ? window.location.host.substring(4, 8)
  : window.location.host.startsWith("localhost")
    ? "development"
    : "prod";

/* Sentry.init({
  dsn: config.SENTRY_URL,
  release: "wa:fe@" + version,
  environment,
  ignoreErrors: [
    /^.*ResizeObserver.*$/, //filtrovani nepodstatneho exception, ktere je mozne ignorovat; v novejsich verzich ant je jiz opraveno
    /^.*_avast_submit.*$/,
    /^.*: User not found*$/,
    "Error: Out of memory",
    "Error: Neurčená chyba.",
    "RangeError: Array buffer allocation failed",
    'TypeError: can\'t redefine non-configurable property "userAgent"',
    "Cannot read properties of null (reading 'formAvailible')",
    /^Cannot read properties of.*$/,
    /^.*Failed to execute 'removeChild' on 'Node'.*$/,
    /^.*Non-Error promise rejection captured.*$/, //nejaky outlook shit
    "Object expected",
  ],
}); */

const node = document.getElementById("nonce-value");
document.head.querySelector('meta[property="csp-nonce"]').content = node
  ? node.getAttribute("value")
  : "";

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root"),
);
